var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-arrow-left';
                    var viewUrl = 'sprite.svg#view-icon-arrow-left';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };